import { ColumnLayout, defineComponent, inferProps, renderSlot, type ReactiveComponent } from "vue-utils"
import BootstrapButton, { type BootstrapButtonColorType } from "../BootstrapButton"

interface Props {
	buttonColor?: BootstrapButtonColorType
	confirmText: string
	confirmIcon?: string

	cancelText?: string

	onConfirm(): void
	onCancel(): void
}

const DangerForm: ReactiveComponent<Props> = (props, { slots }) => {
	return () => (
		<form
			onSubmit={(e) => {
				e.preventDefault()
				props.onConfirm()
			}}
		>
			{renderSlot(slots)}
			<hr class="w-100" />
			<div class="d-flex justify-content-end">
				<ColumnLayout spacing="1rem" columns={2}>
					<BootstrapButton color="secondary" onClick={props.onCancel}>
						{props.cancelText ?? "Cancel"}
					</BootstrapButton>
					<BootstrapButton color={props.buttonColor ?? "danger"} type="submit">
						{props.confirmIcon && <i class={props.confirmIcon} />}
						{props.confirmText}
					</BootstrapButton>
				</ColumnLayout>
			</div>
		</form>
	)
}

export default defineComponent(DangerForm, inferProps<Props>())
